import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { PickTimeDataProvider } from '@services/integrations/pickTime/pickTime.data.service';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';
import { PicTimeDataResponse, ServerDataResponse } from '@models/models';

@Component({
	selector: 'integrate-pick-time-modal',
	template: require('./pre-integrate-pick-time-modal.html')
})
export class PreIntegratePickTimeModal implements OnDestroy {
	button_disabled: boolean;
	exampleDomainName = 'DomainName';
	typedDomainName: string;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private activeModal: NgbActiveModal,
		private pickTimeDataProvider: PickTimeDataProvider,
		private messageService: MessageService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onDismiss(): void {
		this.activeModal.close(true);
	}

	savePickTimeSettings(): void {
		if (!this.typedDomainName) {
			this.messageService.showToaster('e_2', 'picTime');
			return;
		}
		this.button_disabled = true;
		const slicedDomainName = this.typedDomainName
			.replace('https://', '')
			.split('.')[0];

		const regex = /^[a-z0-9]{1,63}$/;
		if (!slicedDomainName.match(regex)) {
			this.messageService.showToaster('e_5', 'picTime');
			this.button_disabled = false;
		} else {
			this.pickTimeDataProvider
				.initPickTimeIntegration(slicedDomainName)
				.pipe(takeUntil(this.unsubscribe))
				.subscribe(
					(data: ServerDataResponse<PicTimeDataResponse>): void => {
						this.messageService.showToaster('i_0', 'picTime');
						this.doRedirect(data.data.integrationUrl);
					},
					error => {
						this.button_disabled = false;
						this.messageService.handleError(error);
					}
				);
		}
	}

	doRedirect(url: string): void {
		window.location.assign(url);
	}

	validateUrlOnPaste(event: ClipboardEvent) {
		const clipboardData = event.clipboardData;
		const pastedText = clipboardData.getData('text').trim();
		this.typedDomainName = pastedText.replace(/\s+/g, '');
		event.preventDefault();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal.ts